var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560 1214 c-67 -18 -141 -64 -178 -113 -43 -54 -49 -69 -16 -40 44 40 73 52 129 52 53 0 85 -12 121 -45 21 -19 22 -19 68 10 81 52 161 50 226 -4 42 -36 38 -17 -7 32 -93 101 -218 140 -343 108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461 1016 c-46 -15 -74 -55 -74 -105 0 -133 176 -160 213 -33 25 89 -54 167 -139 138z m102 -47 c39 -42 36 -82 -8 -126 -31 -31 -40 -35 -68 -29 -97 19 -112 149 -22 187 31 13 67 1 98 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 968 c-31 -43 -10 -138 29 -138 22 0 45 41 45 80 0 39 -23 80 -45 80 -8 0 -21 -10 -29 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761 1016 c-98 -32 -101 -172 -4 -212 72 -31 143 21 143 105 0 81 -65 132 -139 107z m99 -42 c53 -52 20 -145 -57 -160 -28 -6 -37 -2 -68 29 -41 41 -46 81 -14 121 41 52 93 55 139 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766 968 c-36 -51 -2 -158 41 -132 29 18 40 78 20 119 -19 40 -39 44 -61 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 678 c0 -116 5 -230 11 -260 24 -110 90 -203 178 -251 46 -26 50 -26 55 -9 5 15 16 19 54 18 44 -1 47 -3 50 -29 3 -21 9 -27 28 -27 20 0 24 5 24 29 0 27 2 28 50 28 48 0 50 -1 50 -28 l0 -29 105 0 105 0 0 375 c0 206 -2 375 -4 375 -2 0 -16 -25 -31 -55 -42 -88 -131 -127 -230 -102 -27 6 -33 3 -54 -28 -30 -44 -45 -44 -73 0 -21 31 -26 34 -53 28 -55 -14 -112 -7 -159 21 -36 21 -51 39 -75 89 l-30 62 -1 -207z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cdfd01071d1a6f13e689b2a19efef55f.svg";
export { ForwardRef as ReactComponent };